import React from 'react'
import classnames from 'classnames'

export default (props) => {
  const {
    alt,
    title,
    src,
    width,
    height,
    style = {},
    className,
    onError,
    shape,
    errorImgSrc,
    type,
    ...others
  } = props

  const styles = {
    ...style,
    display: 'inline-block',
    width,
    height,
    overflow: 'hidden',
  }
  if (shape === 'rounded') {
    styles.borderRadius = '5px'
  } else if (shape === 'circle') {
    styles.borderRadius = '50%'
  }

  const centerStyles = {
    width,
    height,
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'center',
  }

  const imgStyles = {
    width: 'auto',
    height: 'auto',
    maxWidth: width,
    maxHeight: height,
  }

  const cls = classnames('tntd-img', shape, className)

  return (
    <div className={cls} style={styles} {...others}>
      <div style={centerStyles}>
        <img style={imgStyles} onError={onError} src={src} alt={alt} title={title} />
      </div>
    </div>
  )
}
